export default __webpack_public_path__ + "static/media/khd_popup_bg.db25b9fe.png";